import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import ApiService from "app/services/config";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SendIcon from "@mui/icons-material/Send";
import { AnamnesisItem } from "app/components/AnamnesisItem/AnamnesisItem";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { data } from "app/shared/metrics/SalesStatistics/data";
import AnamnesisQuestion from "app/components/AnamnesisQuestion/AnamnesisQuestion";
import AnamnesisMenu from "app/components/AnamnesisMenu/AnamnesisMenu";

const ChildrensAnamnesisForm = ({ nestedTab, questionaryId }) => {
  const { id, userId } = useParams();
  const QUESTIONARY_ID = questionaryId || 57; // ID DO QUESTIONÁRIO DE ANAMNESE INFANTIL
  const { enqueueSnackbar } = useSnackbar();
  const storedColaboratorId = localStorage.getItem("id");

  const [anamnesis, setAnamnesis] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [anamnesisSelected, setAnamnesisSelected] = useState(null);
  const [answers, setAnswers] = useState(new Map());
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleGetQuestions = async () => {
    setIsLoading(true);
    try {
      await ApiService.get(`/quizzes/quiz/questions/${QUESTIONARY_ID}`).then(
        (response) => {
          if (response.status === 200) {
            setQuestions(response.data);
          }
        }
      );
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Erro ao obter o questionário", {
        variant: "error",
      });
    }
    setIsLoading(false);
  };

  const handleGetAnamnesis = async () => {
    try {
      await ApiService.get(
        `/user-answered/anamnese/distinct/date/${userId}/${QUESTIONARY_ID}`
      ).then((response) => {
        console.log(response);
        if (response.status === 200) {
          console.log(response.data);
          setAnamnesis(response.data);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetAnswer = (answer) => {
    setAnswers(answers.set(answer.pergunta_id, answer));
  };

  useEffect(() => {
    handleGetQuestions();
    handleGetAnamnesis();
    setAnswers(new Map());
  }, [QUESTIONARY_ID, questionaryId, nestedTab, isFormSubmitted]);
  return (
    <>
      {/* MODULARIZAR E COMPONENTIZAR MELHOR ISSO EM BREVE */}
      {isLoading && (nestedTab === 2 || nestedTab === 3) ? (
        <Grid container justifyContent="center" alignItems="center">
          <Stack
            direction="column"
            gap={2}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <CircularProgress color="primary" />
            <Typography>Carregando...</Typography>
          </Stack>
        </Grid>
      ) : (
        <>
          <Grid container rowSpacing={2}>
            <AnamnesisMenu
              anamnesisSelected={anamnesisSelected}
              setAnamnesisSelected={setAnamnesisSelected}
              idQuestionario={QUESTIONARY_ID}
              userId={userId}
              setIsEditMode={setIsEditMode}
              handleGetAnamnesis={handleGetAnamnesis}
              answers={answers}
              anamnesis={anamnesis}
              setAnswers={setAnswers}
              setAnamnesis={setAnamnesis}
              isFormSubmitted={isFormSubmitted}
              setIsFormSubmitted={setIsFormSubmitted}
            />
            {questions &&
              questions?.secoes?.map((secao, index) => (
                <Grid item xs={12}>
                  <Accordion
                    key={index}
                    expanded={expanded === `panel${index}`}
                    onChange={handleAccordionChange(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ArrowDownwardIcon />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                    >
                      <Typography>{secao?.nome}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {secao?.Subsecao?.length === 0 ? (
                        <>
                          {secao?.perguntas?.map((pergunta) => (
                            <AnamnesisQuestion
                              nome={pergunta?.nome}
                              idPergunta={pergunta.id}
                              respostas={pergunta?.Resposta}
                              answers={answers}
                              setAnswers={setAnswers}
                              setIsFormSubmitted={setIsFormSubmitted}
                              anamnesisSelected={anamnesisSelected}
                            />
                          ))}
                        </>
                      ) : (
                        <>
                          {secao?.Subsecao?.map((subsecao) =>
                            subsecao.perguntas?.map((pergunta) => (
                              <AnamnesisQuestion
                                nome={pergunta?.nome}
                                idPergunta={pergunta.id}
                                respostas={pergunta?.Resposta}
                                answers={answers}
                                setAnswers={setAnswers}
                                setIsFormSubmitted={setIsFormSubmitted}
                                anamnesisSelected={anamnesisSelected}
                              />
                            ))
                          )}
                        </>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
          </Grid>
          <Grid
            container
            my={1}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Button
              variant="outlined"
              endIcon={<SendIcon />}
              onClick={() => {
                answers.delete(undefined);
                const arrayRespostas = answers.values().toArray();
                if (isEditMode) {
                  ApiService.put(
                    `/user-answered/user/${userId}/colaborator/${Number(
                      storedColaboratorId
                    )}`,
                    arrayRespostas
                  )
                    .then((response) => {
                      if (response.status === 200) {
                        enqueueSnackbar("Anamnese atualizada com sucesso!", {
                          variant: "success",
                        });
                        setAnamnesisSelected(null);
                        setIsEditMode(false);
                        setIsFormSubmitted(!isFormSubmitted);
                        setAnswers(new Map());
                      }
                    })
                    .catch((error) => {
                      const errorMessage = error.response.data.message;
                      console.log(errorMessage);
                      if (Array.isArray(errorMessage)) {
                        enqueueSnackbar(`${errorMessage[0]}`, {
                          variant: "error",
                        });
                      } else {
                        enqueueSnackbar(`${errorMessage}`, {
                          variant: "error",
                        });
                      }
                    });
                } else {
                  ApiService.post(
                    `/user-answered/user/${userId}/colaborator/${Number(
                      storedColaboratorId
                    )}`,
                    arrayRespostas
                  )
                    .then((response) => {
                      if (response.status === 201) {
                        enqueueSnackbar("Anamnese registrada com sucesso!", {
                          variant: "success",
                        });
                        handleGetAnamnesis();
                        setAnamnesisSelected(null);
                        setIsEditMode(false);
                        setIsFormSubmitted(!isFormSubmitted);
                        setAnswers(new Map());
                      }
                    })
                    .catch((error) => {
                      const errorMessage = error.response.data.message;
                      console.log(errorMessage);
                      if (Array.isArray(errorMessage)) {
                        enqueueSnackbar(`${errorMessage[0]}`, {
                          variant: "error",
                        });
                      } else {
                        enqueueSnackbar(`${errorMessage}`, {
                          variant: "error",
                        });
                      }
                    });
                }
              }}
            >
              {isEditMode ? "Salvar" : "Criar"}
            </Button>
          </Grid>
        </>
      )}
    </>
  );
};

export default ChildrensAnamnesisForm;
